export const HIDE_LAYOUT_BARS_QUERY_PARAM = "hideLayoutBars";

export const getHideLayoutBarsOverride = ({
  search,
}: {
  search: string;
}): boolean | null => {
  const searchParams = new URLSearchParams(search);
  const hideLayoutBarsValue = searchParams.get(HIDE_LAYOUT_BARS_QUERY_PARAM);

  if (hideLayoutBarsValue === "true") {
    return true;
  }

  if (hideLayoutBarsValue === "false") {
    return false;
  }

  return null;
};

export const shouldHideLayoutBars = ({
  search,
}: {
  search: string;
}): boolean => {
  return getHideLayoutBarsOverride({ search }) === true;
};

export const withHideLayoutBarsTrue = ({
  search,
}: {
  search: string;
}): string => {
  const searchParams = new URLSearchParams(search);
  searchParams.set(HIDE_LAYOUT_BARS_QUERY_PARAM, "true");

  return `?${searchParams.toString()}`;
};
